/**
 *
 * 详细参考 https://lanhuapp.com/web/#/item/project/detailDetach?pid=07b98814-45cf-48c0-adcb-47f3f216a411&image_id=72028b8f-0228-4547-b681-0919cf4f4d04&tid=f697b8f1-7af3-4d92-8376-edcfea999d2b&project_id=07b98814-45cf-48c0-adcb-47f3f216a411&fromEditor=true
 *
 * */

// // checkbox
// export const type1 = 32;
// // 学生姓名 课程类型 课时 订单状态 退款状态 餐段
// export const type2 = 90;
// // 家长手机 年级班级 订单金额 (元) 报名方式 支付方式 用餐日期
// export const type3 = 120;
// // 订单编号 课程ID 下单时间 菜品套餐名称 商品ID
// export const type4 = 19010;
// // 学期
// export const type5 = 200;
// // 学校名称
// export const type6 = 240;
// // 课程名称
// export const type7 = 360;
// // 是否预报名
// export const type8 = 100;
// export const defaultWidth = 200;
// export const tableHeight = 500;

export const tableColumnsWidth = {
  action: 200,
  type1: 53, // checkbox
  type2: 100, // 学生姓名 课程类型 课时 订单状态 退款状态 餐段 上架状态 上课状态
  type3: 150, // 家长手机 年级班级 订单金额 (元) 报名方式 支付方式 用餐日期
  type4: 200, // 订单编号 课程ID 下单时间 菜品套餐名称 商品ID
  type5: 200, // 学期 修改备注
  type6: 240, // 学校名称
  type7: 360, // 课程名称
  type8: 130, //
  type9: 120, //
  default: 200
}

export const key = (title, key, width, config = {}) => {
  const obj = {
    title: title,
    align: 'left',
    key: key,
    minWidth: width
  }
  return Object.assign(obj, config)
}

export const slot = (title, key, width, config = {}) => {
  const obj = {
    title: title,
    align: 'left',
    slot: key,
    minWidth: width
  }
  return Object.assign(obj, config)
}
export function renderFn(h, params) {
  const keyVal = params.column.key

  if (params.row[keyVal] && params.row[keyVal].length > 26) {
    return h(
      'Tooltip',
      {
        props: { placement: 'top-start' }
      },
      [
        maxSlice(params.row[keyVal]),
        h(
          'span',
          {
            slot: 'content',
            style: {
              whiteSpace: 'normal',
              wordBreak: 'break-all'
            }
          },
          params.row[keyVal]
        )
      ]
    )
  } else {
    return h('span', params.row[keyVal])
  }
}
export const maxSlice = (v) => {
  if (v) {
    return v.length > 26 ? v.slice(0, 26) + '...' : v
  }
}
